export default __webpack_public_path__ + "static/media/techCampBgSmall.34918abd.jpg";